// Toolbar/Inspector/Sidebar icon set — standardized on lucide-react
// (2026-07-11; replaced the mixed hand-drawn SVGs / letter glyphs / emoji /
// repurposed Polotno PNGs). One mapping module so every consumer keeps its
// import names and the whole editor stays on one visual language.
// All icons: 16px default, stroke-based, inherit currentColor.
import React from 'react';
import {
  ArrowUp, ArrowDown, BringToFront, SendToBack,
  AlignStartVertical, AlignCenterVertical, AlignEndVertical,
  AlignStartHorizontal, AlignCenterHorizontal, AlignEndHorizontal,
  AlignLeft, AlignCenter, AlignRight,
  Sparkles, Blend, SlidersHorizontal, Crop,
  FlipHorizontal2, FlipVertical2, Group, Ungroup,
  Copy, Trash2, Droplet, Check, X,
  Lock, Unlock, MoreHorizontal,
  Bold, Italic, Underline, Strikethrough,
  Move, Palette, Replace, MoveHorizontal, MoveVertical, ImagePlus,
  Undo2, Redo2, Magnet, ZoomIn, ZoomOut, Maximize,
  LayoutTemplate, Shapes, Type, Image, Layers, Pencil, QrCode, Settings,
  Save, Printer, Sun, Proportions, Wallet, UserRound,
} from 'lucide-react';

const make = (Lucide) => (props) => <Lucide size={16} strokeWidth={2} aria-hidden="true" {...props} />;

// ---- layer order ----
export const IconLayerUp = make(ArrowUp);
export const IconLayerDown = make(ArrowDown);
export const IconLayerTop = make(BringToFront);
export const IconLayerBottom = make(SendToBack);

// ---- object alignment ----
export const IconAlignLeft = make(AlignStartVertical);
export const IconAlignCenterH = make(AlignCenterVertical);
export const IconAlignRight = make(AlignEndVertical);
export const IconAlignTop = make(AlignStartHorizontal);
export const IconAlignMiddleV = make(AlignCenterHorizontal);
export const IconAlignBottom = make(AlignEndHorizontal);

// ---- text ----
export const IconTextAlignLeft = make(AlignLeft);
export const IconTextAlignCenter = make(AlignCenter);
export const IconTextAlignRight = make(AlignRight);
export const IconBold = make(Bold);
export const IconItalic = make(Italic);
export const IconUnderline = make(Underline);
export const IconStrikethrough = make(Strikethrough);
export const IconSpacing = make(MoveHorizontal);
export const IconLineHeight = make(MoveVertical);

// ---- effects / image ----
export const IconShadow = make(Sparkles);
export const IconEffects = make(Sparkles);
export const IconOutline = make(Blend);
export const IconGradient = make(Blend);
export const IconFilters = make(SlidersHorizontal);
export const IconCrop = make(Crop);
export const IconFlipH = make(FlipHorizontal2);
export const IconFlipV = make(FlipVertical2);
export const IconReplace = make(Replace);
export const IconAddImage = make(ImagePlus);

// ---- object ops ----
export const IconGroup = make(Group);
export const IconUngroup = make(Ungroup);
export const IconDuplicate = make(Copy);
export const IconTrash = make(Trash2);
export const IconOpacity = make(Droplet);
export const IconLock = make(Lock);
export const IconUnlock = make(Unlock);
export const IconMore = make(MoreHorizontal);
export const IconPosition = make(Move);
export const IconStyles = make(Palette);

// ---- misc ----
export const IconCheck = make(Check);
export const IconX = make(X);

// ---- footer ----
export const IconUndo = make(Undo2);
export const IconRedo = make(Redo2);
export const IconSnap = make(Magnet);
export const IconZoomIn = make(ZoomIn);
export const IconZoomOut = make(ZoomOut);
export const IconFit = make(Maximize);

// ---- App Bar / Bar 0 (owner directive 2026-07-21: Save, Print, Poster
// properties, credits/settings/profile moved into THE top chrome) ----
export const IconSave = make(Save);
export const IconPrinter = make(Printer);
export const IconSun = make(Sun);
export const IconPoster = make(Proportions);
export const IconWallet = make(Wallet);
export const IconUser = make(UserRound);
export const IconGear = make(Settings);

// ---- left panel (replaces the repurposed Polotno PNGs — Draw used an
// "Upload" icon and QR Code used "Resize") ----
export const IconPanelTemplates = make(LayoutTemplate);
export const IconPanelElements = make(Shapes);
export const IconPanelText = make(Type);
export const IconPanelMedia = make(Image);
export const IconPanelLayers = make(Layers);
export const IconPanelDraw = make(Pencil);
export const IconPanelQr = make(QrCode);
export const IconPanelSettings = make(Settings);
